import { useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { Button, CardSheetLayout, Loader } from '@/components';
import useAuth from '@/hooks/useAuth';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import useToast from '@/hooks/useToast';
import ROUTES from '@/router/routes';
import { confirmedTeamInfo } from '@/services/buildTeam11';
import { getListTDA } from '@/services/tda';

export const TeamConfirm = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { isMobile } = useIsDesktop();
  const { userInitialData, setUserInitialData } = useAuth();
  const { pinsData } = usePinsAccount();

  useEffect(() => {
    navigate('', { replace: false });
  }, []);

  const { data, isLoading } = useQuery(
    'teamConfirmedInfo',
    async () => await confirmedTeamInfo(),
    {
      refetchOnWindowFocus: false,
      onError: (error) => {
        const errorMsg = error as Error;
        toast.show(errorMsg?.message);
      },
      onSuccess: (data) => {
        if (data && data.estado === false) {
          toast.show(data.mensaje);
        }
      },
    }
  );

  const { data: dataTXP, isLoading: isLoadingTXP } = useQuery(
    'hasTDAXP',
    async () => await getListTDA()
  );

  useEffect(() => {
    if (userInitialData && dataTXP?.estado && !isLoadingTXP) {
      setUserInitialData({
        ...userInitialData,
        tiene_equipo: true,
        showTDAP:
          dataTXP?.abiertos.length > 0 || dataTXP?.participaciones.length > 0,
      });
    }
  }, [dataTXP, isLoadingTXP, setUserInitialData, userInitialData]);

  const fechaActiva = useMemo(() => {
    if (userInitialData && data && data.estado) {
      return userInitialData.todasLasFechas.find(
        (fecha) => fecha.orden === data.ordenFecha
      );
    }

    return null;
  }, [data, userInitialData]);

  const handleClickMyTeam = () => {
    navigate(ROUTES.myTeam11, {
      replace: true,
    });
  };

  if (data && data.estado) {
    return (
      <>
        {<Loader isVisible={isLoading} timeout={false} />}
        <CardSheetLayout
          footerComplex
          showFooter
          bgClassName="bg-confirm-team"
          bgLabel={
            isMobile
              ? 'jugador pisando una pelota de futbol'
              : 'dos jugadores jugando con una pelota de futbol'
          }
          cardClassName="px-4 lg:px-9 lg:py-8 xl:pt-11 xl:pb-[3rem]"
          innerCardClassName="lg:max-w-full"
          isPremium={pinsData.isPremium}
        >
          <div className="space-y-6">
            <h1 className="m-auto text-gdt-gray uppercase font-normal font-bebas text-3xl text-center leading-8">
              ¡Tu equipo está confirmado!
            </h1>
            <p className="text-center font-normal text-sm text-gdt-gray">
              Podés hacer cambios y transferencias ilimitadas hasta el comienzo
              de la competencia. <br className="block lg:hidden" /> Tu 11
              comenzará a sumar puntos en la {fechaActiva?.nombre ?? '-'}{' '}
              {data?.txtInicioVeda && `(${data?.txtInicioVeda})`} del Torneo{' '}
              {data.torneo}.
            </p>
            <div className="flex gap-2">
              {/* <Button className="w-full py-3" type="button" variant="secondary">
                Crear camiseta
              </Button> */}
              <Button
                className="w-full py-3"
                type="button"
                variant="primary"
                onClick={handleClickMyTeam}
              >
                Ir a Mi Equipo
              </Button>
            </div>
          </div>
        </CardSheetLayout>
      </>
    );
  }

  return null;
};
